import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CatButton } from "blocks-nextjs/blocks-react/components/Button/Button";
import { CatModal } from "blocks-nextjs/blocks-react/components/Modal/Modal";
import React, { useCallback, useState } from "react";
import { createPortal } from "react-dom";
const DeleteAssetModal = ({ onConfirmDelete }) => {
    const [isDeleteModalActive, setIsDeleteModalActive] = useState(false);
    const onDeleteClick = useCallback(() => {
        setIsDeleteModalActive(true);
    }, []);
    const onDeleteConfirm = useCallback(() => {
        setIsDeleteModalActive(false);
        onConfirmDelete?.();
    }, [onConfirmDelete]);
    const onDeleteCancel = useCallback(() => {
        setIsDeleteModalActive(false);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(CatButton, { "data-test": "delete-from-site-button", onClick: onDeleteClick, variant: "danger", children: "Delete from Site" }), isDeleteModalActive &&
                createPortal(_jsxs(CatModal, { className: "[&::part(close)]:hidden", "data-test": "delete-confirm-modal", disableBackdropClick: true, heading: "Are you sure?", headingVariant: "title", isActive: isDeleteModalActive, onBlModalClose: () => {
                        onDeleteCancel();
                    }, size: "sm", children: [_jsx("p", { className: "text-[#3F3F3F]", children: "This asset will be removed from the site, but it won't be permanently deleted." }), _jsxs("div", { className: "flex gap-3", slot: "footer", children: [_jsx(CatButton, { "data-test": "delete-confirm-button", onClick: onDeleteConfirm, variant: "danger", children: "Delete from Site" }), _jsx(CatButton, { "data-test": "delete-cancel-button", onClick: onDeleteCancel, variant: "ghost", children: "Cancel" })] })] }), document.body)] }));
};
export default DeleteAssetModal;
